import { backendURL } from '../../lib/config';

/**
 * The free text disclaimers, set in the marketing portal. With the
 * freeTextDisclaimers flag on, `plans` replaces the hard-coded text under
 * the plans, and the two replace the campaign and promo code terms
 * (`discount.terms`): `plans` under the plans, `checkout` at the payment step.
 */
export interface Disclaimers {
  plans: string;
  checkout: string;
}

export const disclaimersURL = (): string => new URL(
  '/api/v1/public/disclaimers',
  backendURL,
).toString();
